export default __webpack_public_path__ + "static/media/salami-kawalek.9f749267.webp";